const general = {
  formatNum: (numero) => {
    let num = numero
    if(numero<0){
      num = (num * -1).toString()
    }
    num = num.replace(/\./g,'');
    if(!isNaN(num)){
      num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g,'$1.');
      num = num.split('').reverse().join('').replace(/^[.]/,'');
      if(numero<0){
        num = "-" + num
      }
      // console.log(num)
    }
    return num
  }
}

export default general
